import React from 'react';
import { Box } from '@mui/material';
import CommonImages from '../../../commons/images';
import useDotLottie from './useDotLottie';
import * as styles from './styles';

// ECAL's standard loading indicator (EBL-13079) — matches admin-v4-ui's
// LoadingAnimation so both apps show the same "connector dots" instead of
// a plain MUI spinner.
function LoadingAnimation() {
    const { canvasRef } = useDotLottie({ src: CommonImages.ECAL_LOADING_LOTTIE });

    return (
        <Box sx={styles.wrapper}>
            <Box
                component="canvas"
                ref={canvasRef}
                sx={styles.canvas}
                role="img"
                aria-label="loading"
            />
        </Box>
    );
}

export default LoadingAnimation;
